import { number, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Area = struct({
	x: number,
	y: number,
	width: number,
	height: number,
});

export const NormalizedArea = struct({
	x: iotsUtils.NormalizedCoordinate,
	y: iotsUtils.NormalizedCoordinate,
	width: iotsUtils.NormalizedCoordinate,
	height: iotsUtils.NormalizedCoordinate,
});
